"use strict";

angular.module("customer")
.service("PromotionCatalogEntryService", function($resource, $stateParams, $compile, appConfig) {
    var resource = $resource(appConfig.API_SERVER + "/catalog/customer/products/advertised/", {}, {
        query: {
            method: "GET",
            isArray: false,
            ignoreLoadingBar: true
        }
    });

    this.compile = function(scope, value, slick) {
        scope.catalogEntry = value;
        scope.slick = slick;
        return $compile("<promotion-catalog-entry class='slick-item-wrap'></promotion-catalog-entry>")(scope);
    };

    this.query = function(page) {
        var search = $stateParams.search;
        var vendor = $stateParams.vendorId;
        var catalog = $stateParams.catalog;

        var params = {
            page: page,
            advertise_promotion: (search || vendor || catalog) ? undefined : 1,
            promotional: 1,
            direction: "-",
            field: "promotion_reference_date",
            ignore_preferred_mode: 1,
            search: search,
            vendor: vendor,
            catalog: catalog,
            product_category: $stateParams.categories
        };

        return resource.query(params).$promise;
    };
});



//////////////////
// WEBPACK FOOTER
// ./customer/app-core/promotion-catalog-entry/promotion-catalog-entry.service.js
// module id = 846
// module chunks = 0